import { render } from "./SetScore.vue?vue&type=template&id=fbbb324c&scoped=true"
import script from "./SetScore.vue?vue&type=script&lang=js"
export * from "./SetScore.vue?vue&type=script&lang=js"

import "./SetScore.vue?vue&type=style&index=0&id=fbbb324c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Kuppen_front/Kuppen_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbbb324c"]])

export default __exports__